import {
  ArrowIcon,
  Button,
  DestructiveIcon,
  Modal,
  ModalContent,
  ModalFooter,
  ModalTitle,
  Text,
} from '@modusign/design-system';
import { useCallback } from 'react';
import { useHistory } from 'react-router';

interface SigningRequestFeatureGuideModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const defaultProps = {
  isOpen: false,
  onClose() {},
};

function SigningRequestFeatureGuideModal({
  isOpen,
  onClose,
}: SigningRequestFeatureGuideModalProps) {
  const history = useHistory();

  const handleCancelClick = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleConfirmClick = useCallback(() => {
    history.push('/settings/plan');
    onClose();
  }, [history, onClose]);

  if (!isOpen) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} maxWidth="xs" onClose={handleCancelClick}>
      <ModalTitle icon={<DestructiveIcon color="iconPrimaryBase" />}>서명 요청 안내</ModalTitle>
      <ModalContent>
        <Text as="p" textAlign="center" whiteSpace="pre-wrap">
          잔여 건수가 부족하여 서명 요청을 진행할 수 없습니다. <br />
          사용량 충전 후 다시 진행해 주세요.
        </Text>
      </ModalContent>
      <ModalFooter>
        <Button mr={3} onClick={handleCancelClick}>
          취소
        </Button>
        <Button variant="primary" onClick={handleConfirmClick}>
          요금제 확인하기 <ArrowIcon direction="right" ml={1} />
        </Button>
      </ModalFooter>
    </Modal>
  );
}

SigningRequestFeatureGuideModal.defaultProps = defaultProps;

export default SigningRequestFeatureGuideModal;
